export const isBase64Image = (file) => {
    return typeof file === "string" && file.startsWith("data:image/");
};

export const isBase64Video = (file) => {
    return typeof file === "string" && file.startsWith("data:video/");
};

export const isVideoThumbnail = (url) => {
    return typeof url === "string" && url.includes("/video/");
};